import CaseAssignmentForm from "../components/ui/form-case-assignment.js";
import CurrentCaseRequired from "../components/ui/current-case-required.js";
//import CaseDatabaseCheck from "../components/ui/case-database-check.js";



export default function ManageCaseAssignmentPage() {
  return (
    <CurrentCaseRequired>
      <CaseAssignmentForm/>
    </CurrentCaseRequired>
  );

};